import { STOPWORDS } from './stopwords';
import { stem } from './stem';

const SPLIT_RE = /[^a-z0-9]+/i;

/**
 * Lowercase, split on non-alphanumerics, drop stopwords and 1-char tokens,
 * then stem. Returns the token sequence used for both indexing and querying —
 * same pipeline both sides, otherwise BM25 misses on perfectly valid matches.
 */
export function tokenize(text: string): string[] {
  if (!text) return [];
  const out: string[] = [];
  for (const raw of text.toLowerCase().split(SPLIT_RE)) {
    if (raw.length < 2) continue;
    if (STOPWORDS.has(raw)) continue;
    const s = stem(raw);
    if (s.length < 2) continue;
    out.push(s);
  }
  return out;
}
